import { BaseModel } from "model/BaseModel";
import Usuario from "./Usuario";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";

export default class Setor implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    responsavel: Usuario | null;
    geraAuditoriaApp: boolean;
    planos: SetorPlanoAuditoria[];
    auditor: Usuario | null;
    unidadeOrganizacional: UnidadeOrganizacional | null;
    emailsEnviar: string[] | null;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        responsavel = null,
        gerarAuditoriaApp = false,
        planos=[],
        auditor = null,
        unidadeOrganizacional = null,
        emailsEnviar = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.responsavel = responsavel;
        this.geraAuditoriaApp = gerarAuditoriaApp;
        this.planos = planos;
        this.auditor = auditor;
        this.unidadeOrganizacional = unidadeOrganizacional;
        this.emailsEnviar = emailsEnviar;
    }


}
